<template>
  <div id="app" class="helvetica">
    <div class="bg-overlay aspect-ratio--object fixed bg-white" :class="{ 'bg-invert': invert == true }" style="z-index: 1;"></div>
    <div class="texture aspect-ratio--object fixed"></div>
    <div class="fixed vh-100-l h-auto-m h-auto" style="z-index: 108;" v-if="!showScrollIndicator">
      <div class="home-heading vh-100-l h-auto-m h-auto v-mid-l dtc-l ttu pl4-l">
        <h1 style="pointer-events: none;" v-if="!showContact" id="" :class="{ 'txt-invert': invert == true }" id="" class="f-6-l f-5-m f2 black no-underline mv0">Leonidas<br>Diamantis</h1>
        <h1 style="pointer-events: none;" v-if="!showContact" id="" :class="{ 'txt-invert': invert == true }" id="" class="f-6-l f-5-m f2 black no-underline mv0">Music<br>Creative</h1>
        <h1 v-if="!showContact" id="about" @click="showContactFunction()" :class="{ 'txt-invert': invert == true }" class="f-6-l f-5-m f2 black pointer no-underline mv0">ABOUT</h1>
      <!-- </router-link> -->
      </div>
    </div>
    <contact v-if="showContact" :class="{ 'z-999': showContact }" v-on:closeContact="closeContact()"></contact>
    <vue-page-transition name="fade">
      <router-view v-on:invert="flipColors()" v-on:scrolling="showScrollIndicator = false; invert = false;"/>
    </vue-page-transition>
    <!-- <contact></contact> -->
  </div>
</template>
<script>
// @ is an alias to /src
import Contact from '@/components/Contact.vue'

export default {
  name: 'App',
  components: {
    // Item
    Contact
  },
  data() {
    return {
      showContact: false,
      invert: true,
      showScrollIndicator: true
    }
  },
  methods: {
    flipColors() {
      // console.log('INVERT');
      this.invert = !this.invert;
      // console.log(this.invert);
    },
    closeContact() {
      // console.log('caught close contact');
      this.showContact = false;
      document.body.style.overflow = 'scroll';
    },
    showContactFunction() {
      this.showContact = true;
      document.body.style.overflow = 'hidden';
    }
  }
}
</script>
<style>
  html {
    scroll-behavior: smooth;
  }

  body {
    /*background-color: white;*/
    /*color: black;*/
  }

  a {
    text-decoration: none;
  }

  h1 {
    line-height: 0.8;
  }

  .texture {
    pointer-events: none;
    background-image: url('~@/assets/texture.png');
    opacity: 0.4;
    background-size: cover;
  }

  .link:focus { outline: none; }
  img {outline : none;}

  ::selection {
    background: #000; /* WebKit/Blink Browsers */
    color: #fff;
  }
  ::-moz-selection {
    background: #000; /* Gecko Browsers */
    color: #fff;
  }

  #about {
    display: inline-block;
    width: auto;
  }

  #about:hover {
    color: white;
    background-color: black;
  }

  #title {
    position: absolute;
    left: 20px;
    text-transform: uppercase;
    z-index: 2;
  }

  #title-right {
    position: absolute;
    right: 20px;
    text-transform: uppercase;
    z-index: 2;
  }

  .nav-title.router-link-active {
    /*display: none;*/
  }

  .txt-invert {
    color: white;
  }

  .white.txt-invert {
    color: black;
  }

  .purple-bg-invert {
    background-color: #78D308 !important;
  }

  .purple-txt-invert {
    color: #78D308;
  }

  .txt-green {
    color: #78D308;
  }

  .bg-invert {
    background-color: black;
  }

  .invert-filter {
    filter: invert(100%);
    -webkit-filter: invert(100%);
    /*background-color: black;*/
  }

  #scroll-up {
    top: 10px;
    right: 20px;
    z-index: 150;
  }

  #scroll-down {
    bottom: 10px;
    right: 20px;
    z-index: 150;
  }


@keyframes flickerAnimation {
  0%   { opacity:1; }
  9%  { opacity:1; }
  10%  { opacity:0; }
  19%   { opacity:0; }
  20%   { opacity:1; }
  29%   { opacity:1; }
  30%   { opacity:0; }
  100% { opacity:0; }
}
@-o-keyframes flickerAnimation{
  0%   { opacity:1; }
  9%  { opacity:1; }
  10%  { opacity:0; }
  19%   { opacity:0; }
  20%   { opacity:1; }
  29%   { opacity:1; }
  30%   { opacity:0; }
  100% { opacity:0; }
}
@-moz-keyframes flickerAnimation{
  0%   { opacity:1; }
  9%  { opacity:1; }
  10%  { opacity:0; }
  19%   { opacity:0; }
  20%   { opacity:1; }
  29%   { opacity:1; }
  30%   { opacity:0; }
  100% { opacity:0; }
}
@-webkit-keyframes flickerAnimation{
  0%   { opacity:1; }
  9%  { opacity:1; }
  10%  { opacity:0; }
  19%   { opacity:0; }
  20%   { opacity:1; }
  29%   { opacity:1; }
  30%   { opacity:0; }
  100% { opacity:0; }
}
.animate-flicker {
   -webkit-animation: flickerAnimation 1.5s infinite;
   -moz-animation: flickerAnimation 1.5s infinite;
   -o-animation: flickerAnimation 1.5s infinite;
    animation: flickerAnimation 1.5s infinite;
}

</style>
